module.exports = __webpack_public_path__ + "img/yishi5.10db5a73.jpg";